<template>
    <zk-search-form-inline :form="form" @search="$emit('search', form)">
        <el-form-item label="二级单位">
            <select-subsidiary-2 v-model="form.EJDWID" />
        </el-form-item>
        <el-form-item label="三级单位">
            <select-subsidiary-3 :ejdw_id="form.EJDWID" v-model="form.SJDWID" />
        </el-form-item>
        <el-form-item label="姓名">
            <el-input v-model.trim="form.XM" clearable></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
            <el-input v-model.trim="form.SFZH" clearable></el-input>
        </el-form-item>
    </zk-search-form-inline>
</template>

<script>
export default {
    data() {
        return {
            form: {}
        }
    }
}
</script>

